const isStaging = () => {
  // 'staging.buvidal.com.au'
  if(window.location.host.includes('staging')) {
    return true
  } else {
    return false
  }
}

export default isStaging;